import { PaymentMethod } from "../../../common/payment";
import { orderApi } from "../../order/orderApi";
import { getTableTokenHeaders } from "../../partyOnboarding/persistence/tableToken";
import { ProblemDetailsError } from "../../order/orderApi/ProblemDetailError";

export async function fetchPaymentMethodSession<T extends Record<string, string>>(paymentMethod: PaymentMethod) {
    const { paymentGateway } = paymentMethod;

    const response = await orderApi.send(`/paymentgateway/${paymentGateway}/vaultedpaymentmethods/session`, {
        method: "POST",
        headers: getTableTokenHeaders(),
    });

    await ProblemDetailsError.throwError(response);

    return (await response.json()) as T;
}
